import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight, Plus } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-cream-light py-20 px-4 md:px-6 border-t border-cream-dark/5" data-id="element-154">
      <div className="max-w-4xl mx-auto text-center" data-id="element-155">
        {/* Main Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-xl overflow-hidden border border-teal/10 relative mb-12" data-id="element-156">
          <div className="bg-teal text-white py-3 text-sm font-medium tracking-wider uppercase" data-id="element-157">
            Oferta Especial
          </div>

          <div className="p-8 md:p-12" data-id="element-158">
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-159">
              <img src="https://cdn.magicpatterns.com/uploads/4Mum7Qw3v6dksu3JCu6coL/menopausia_sin_castigo.png" alt="Product Mockup" className="w-48 md:w-64 drop-shadow-lg" data-id="element-160" />
              <div className="text-left" data-id="element-161">
                <h3 className="text-3xl font-serif font-bold text-warm-dark mb-2" data-id="element-162">
                  Menopausia Sin Castigo
                </h3>
                <p className="text-teal-dark font-medium mb-4" data-id="element-163">
                  Reset Anti-Inflamación (21 días)
                </p>
                <div className="flex items-baseline gap-3 mb-2" data-id="element-164">
                  <span className="text-2xl text-warm-gray line-through" data-id="element-165">
                    $29
                  </span>
                  <span className="text-5xl font-bold text-teal" data-id="element-166">$6.39</span>
                  <span className="text-warm-gray text-lg" data-id="element-167">pago único</span>
                </div>
                <p className="text-sm text-warm-gray max-w-xs" data-id="element-168">
                  Porque el objetivo es que lo uses, lo repitas y se convierta
                  en tu sistema.
                </p>
              </div>
            </div>

            <motion.a href="https://tumejorritmo.com/cart/47342312194278:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full md:w-auto bg-teal hover:bg-teal-dark text-white text-xl font-bold py-4 px-12 rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 mx-auto mb-8 cursor-pointer" data-id="element-169">
              Quiero el Reset de 21 días
              <ArrowRight className="w-6 h-6" data-id="element-170" />
            </motion.a>

            {/* Guarantee */}
            <div className="bg-cream/50 rounded-xl p-6 border border-cream-dark/10 max-w-2xl mx-auto" data-id="element-171">
              <div className="flex items-start gap-4" data-id="element-172">
                <ShieldCheck className="text-gold shrink-0 mt-1" size={24} data-id="element-173" />
                <div className="text-left" data-id="element-174">
                  <h4 className="font-bold text-warm-dark mb-1" data-id="element-175">
                    Garantía de 7 días
                  </h4>
                  <p className="text-sm text-warm-gray" data-id="element-176">
                    Prueba el reset 7 días. Si no sientes ninguna mejora en
                    hinchazón / energía / control, pides reembolso. (Sin
                    interrogatorio.)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Order Bump */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-2xl mx-auto bg-white border-2 border-dashed border-gold/30 rounded-xl p-6 flex flex-col md:flex-row items-center gap-6 mb-16" data-id="element-177">
          <div className="bg-gold/10 p-3 rounded-full text-gold" data-id="element-178">
            <Plus size={24} data-id="element-179" />
          </div>
          <div className="text-left flex-1" data-id="element-180">
            <h4 className="font-bold text-warm-dark" data-id="element-181">
              Pack Imprimible: 20 Comidas Seguras + Lista de Super + Tracker
            </h4>
            <p className="text-sm text-warm-gray" data-id="element-182">
              Para cuando no quieres pensar. Solo seguir el plan.
            </p>
          </div>
        </motion.div>

        {/* Final Close */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-2xl mx-auto" data-id="element-183">
          <p className="text-2xl font-serif text-warm-dark mb-6" data-id="element-184">
            "No necesitas otra dieta. Necesitas un cuerpo que se sienta seguro
            otra vez."
          </p>
          <p className="text-lg text-warm-gray mb-8" data-id="element-185">
            Hazlo simple. Hazlo sostenido. Hazlo sin culpa.
          </p>
          <button onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="text-teal font-bold hover:underline cursor-pointer" data-id="element-186">
            Volver arriba para comprar
          </button>
        </motion.div>
      </div>
    </section>;
}